// Flag temporal para modo "landing only".
// Para revertir en el próximo commit, cambia a false.
export const READ_ONLY_LANDING = false;

// Flag para controlar la visibilidad del botón del CRM de WhatsApp.
// Cambia a true para mostrar el botón.
export const SHOW_WHATSAPP_CRM_BUTTON = true;


